import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import RequestAccess from "../../../components/requestAccess/RequestAccess";
import Utils from "../../../utils/Utils";
import Loader from "../../../components/Loader";
import WebUtils from "../../../utils/WebUtils";
import { getModuleAccessInfoApi } from "../../../api/candidate";
import B2BMockInterviewGuide from "../../../components/b2bCandidate/mockInterview/MockInterviewGuide";
import { ROLES } from "../../../constants/UserRoles";

function MockInterview() {
  const userDetail = Utils.getUserDetail();

  const [loading, setLoading] = useState(false);
  const [moduleInfo, setModuleInfo] = useState();

  const getModuleInfo = async () => {
    const url = `${getModuleAccessInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setModuleInfo(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  
  useEffect(() => {
    getModuleInfo();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="mock-interview" userRole={ROLES.b2b_candidate} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="mock-interview"
            userRole={ROLES.b2b_candidate}
            newTitle="iDrona Mock Interview"
            noNavigate={true}
          />
          {/* {moduleInfo?.hasMockInterviewAccess ? ( */}
          <B2BMockInterviewGuide moduleInfo={moduleInfo} />
          {/* ) : (
            <RequestAccess moduleName="MOCK_INTERVIEW" />
          )} */}
        </div>
      </div>
    </>
  );
}

export default MockInterview;
